import { createReducer } from 'reduxsauce'

import importer from 'common/importer'

const { INITIAL_STATE } = importer('Stores/Wirecard/InitialState', null)
const { WirecardTypes } = importer('Stores/Wirecard/Actions', null)

const getWirecardInfoLoading = state => ({
  ...state,
  getWirecardInfoLoading: true,
  getWirecardInfoSuccess: null,
  getWirecardInfoFailure: null
})
const getWirecardInfoSuccess = (state, { res }) => ({
  ...state,
  getWirecardInfoLoading: false,
  getWirecardInfoSuccess: res,
  getWirecardInfoFailure: null
})
const getWirecardInfoFailure = (state, { error }) => ({
  ...state,
  getWirecardInfoLoading: false,
  getWirecardInfoSuccess: null,
  getWirecardInfoFailure: error
})

const cleanWirecardState = state => ({
  ...state,
  getWirecardInfoSuccess: null
})

export const reducer = createReducer(INITIAL_STATE, {
  [WirecardTypes.GET_WIRECARD_INFO_LOADING]: getWirecardInfoLoading,
  [WirecardTypes.GET_WIRECARD_INFO_SUCCESS]: getWirecardInfoSuccess,
  [WirecardTypes.GET_WIRECARD_INFO_FAILURE]: getWirecardInfoFailure,

  [WirecardTypes.CLEAN_WIRECARD_STATE]: cleanWirecardState
})
